export default "__VITE_ASSET__COuIEFgO__"